import React from 'react';
import { useMutation } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import { notification } from "antd";
import { CustomButton } from "../../../components";
import { useHistory } from "react-router-dom";
import { INTERNAL_LINKS } from "enum";

export default function ClassDiploma({ myClass, userProfile }) {
  const history = useHistory();

  const downloadDiplomaMutation = useMutation({
    mutationFn: async () => {
      const { data } = await httpClient.post(`private/certificate-class/${myClass.id}/faculty/diploma`);

      return data
    },
    onSuccess: (data) => {

      if (data.type === "NOT_FINISHED") {
        return notification.info({ message: data.message })
      }

      // Create a data URL from the base64 string
      const dataUrl = `data:image/png;base64,${data.base64Image}`;

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `${userProfile?.firstName} ${userProfile?.lastName} Certificate.png`; // The name of the downloaded file

      // Append the link to the body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the document
      document.body.removeChild(link);
    },
    onError(err) {
      console.log(err)
      notification.error({ message: "Something went wrong" });
    }
  })

  // console.log(myClass, 'myClass')

  return (
    <div style={{ width: "100%"}}>
      <CustomButton 
        text={myClass?.CertificateDiplomas.length > 0 
          ? `View ${myClass?.title} Diploma` 
          : `Download ${myClass?.title} Diploma`
        } 
        loading={downloadDiplomaMutation.isLoading} 
        style={{ width: "100%"}} 
        onClick={() => {
          myClass?.CertificateDiplomas.length > 0 
            ? history.push(
              `${INTERNAL_LINKS.CERTIFICATE_FACULTY_DIPLOMA_VERIFY}/${myClass?.CertificateDiplomas[0]?.code}`,
            )
            : downloadDiplomaMutation.mutate()
        }}  
      />
      {/*{isLoading ? (*/}
      {/*  <div*/}
      {/*    style={{*/}
      {/*      width: "100%",*/}
      {/*      height: "100%",*/}
      {/*      display: "flex",*/}
      {/*      justifyContent: "center",*/}
      {/*      alignItems: "center",*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <img*/}
      {/*      src={IconLoading}*/}
      {/*      style={{ width: "40px", height: "40px" }}*/}
      {/*      alt="loader-digital-certificate"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <img*/}
      {/*    src={`data:image/png;base64,${diploma?.base64Image}`}*/}
      {/*    alt="ceritficate-case"*/}
      {/*    style={{ width: "100%", height: "100%" }}*/}
      {/*  />*/}
      {/*)}*/}
    </div>
  )
}